var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sidebar-logo-container"},[_c('router-link',{key:"expand",staticClass:"sidebar-logo-link",attrs:{"to":"/"}},[_c('div',{staticClass:"sidebar-logo"})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }